import { mapActions } from 'vuex'
import { getKey, removeKey, setKey } from '../../assets/utils'
import { judgeClientSystem } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'

export default {
  data () {
    return {
      // 来源页面，主要为了返回到对应页面
      from: this.$route.query.from
    }
  },
  async created () {
    if (getKey('isVideoMiddleVisited') === 'T') {
      removeKey('isVideoMiddleVisited')
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        if (this.from) {
          location.href = this.from
        } else {
          this.$router.replace('/')
        }
      }
    } else {
      const infoRes = await this.memberInfo()
      if (infoRes.success) {
        if (infoRes.data.memberStatus === 'NORMAL') {
          setKey('isVideoMiddleVisited', 'T')
          const { memberType } = infoRes.data
          if (['EC_M', 'EC_HY', 'EC_Y', 'BC_Y'].includes(memberType)) {
            // 尊享版
            const { success, data } = await this.getToken({
              benefitType: 'LIFE'
            })
            if (success && data) {
              const xsUrl = process.env.VUE_APP_XSOAK
              window.location.href = `${xsUrl}#/pages/benefit_detail/benefit_detail?benefit_type=vip_combo&once=${data.onceToken}&return_url=${encodeURIComponent(this.from)}`
            }
          } else if (['LC_M', 'LC_HY', 'LC_Y'].includes(memberType)) {
            // 轻享版
            const { success, data } = await this.getToken({
              benefitType: 'MONEY_SAVING_CARD'
            })
            if (success && data) {
              const xsUrl = process.env.VUE_APP_XSURL
              window.location.href = `${xsUrl}/xsoak/#/benefit?category=视听娱乐&namespace=ct_life&user_token=${data.jwtToken}&return_url=${encodeURIComponent(this.from)}`
            }
          }
        } else {
          // 未购买或已失效
          this.$router.replace('/secKill/index')
        }
      }
    }
  },
  methods: {
    ...mapActions('vip', ['memberInfo', 'getToken'])
  },
  render () {
    return <div/>
  }
}